import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// SEO and Meta Configuration
const updateMetaTags = () => {
  document.title = 'IMMOACTIVAT I ASSOCIATS SL | Desarrollo Software & Ciberseguridad';
  
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', 
      'Especialistas en desarrollo de software seguro, ciberseguridad e inteligencia artificial. Soluciones digitales innovadoras que protegen y potencian tu negocio.'
    );
  }

  // Add additional meta tags
  const metaTags = [
    { name: 'keywords', content: 'desarrollo software, ciberseguridad, aplicaciones móviles, desarrollo web, inteligencia artificial, seguridad informática, GDPR, privacidad' },
    { name: 'author', content: 'IMMOACTIVAT I ASSOCIATS SL' },
    { name: 'robots', content: 'index, follow' },
    { property: 'og:title', content: 'IMMOACTIVAT I ASSOCIATS SL | Desarrollo Software & Ciberseguridad' },
    { property: 'og:description', content: 'Especialistas en desarrollo de software seguro, ciberseguridad e inteligencia artificial.' },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://immoactivatsiassociats.com' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: 'IMMOACTIVAT I ASSOCIATS SL | Desarrollo Software & Ciberseguridad' },
    { name: 'twitter:description', content: 'Especialistas en desarrollo de software seguro, ciberseguridad e inteligencia artificial.' }
  ];

  metaTags.forEach(tag => {
    let element = document.querySelector(`meta[name="${tag.name}"]`) || 
                  document.querySelector(`meta[property="${tag.property}"]`);
    
    if (!element) {
      element = document.createElement('meta');
      if (tag.name) element.setAttribute('name', tag.name);
      if (tag.property) element.setAttribute('property', tag.property);
      document.head.appendChild(element);
    }
    
    element.setAttribute('content', tag.content);
  });
};

// Update meta tags on load
updateMetaTags();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Performance monitoring
reportWebVitals();
